export default "__VITE_ASSET__Co15JmoP__"